export const Status = (status) => {
  switch (status) {
    case 1:
      return (
        <label className="btn m-0 p-0" style={{ fontSize: "12px" }}>
          <i class="text-success me-2  bi bi-check-circle-fill"></i>
          Activo
        </label>
      );
    case 2:
      return (
        <label className="btn m-0 p-0" style={{ fontSize: "12px" }}>
          <i class="text-secondary me-2  bi bi-slash-circle-fill"></i>
          Pausado
        </label>
      );
    case 3:
      return (
        <label className="btn m-0 p-0" style={{ fontSize: "12px" }}>
          <i class="text-danger me-2  bi bi-trash"></i>
          Eliminado
        </label>
      );
    case 4:
      return (
        <label className="btn m-0 p-0" style={{ fontSize: "12px" }}>
          <i class="text-info me-2  bi bi-recycle"></i>
          Borrador
        </label>
      );
    default:
      return null;
      break;
  }
};

export const StatusText = (status) => {
  switch (status) {
    case 1:
      return "Activo";
    case 2:
      return "Pausado";
    case 3:
      return "Eliminado";
    case 4:
      return "Borrador";
    default:
      return null;
      break;
  }
};
